import React, {Component} from "react";
import BasicInfoBox from "./BasicInfoBox";
import {AnimalTypes} from "../../constans/animalTypes";
import SowCard from "./cards/SowCard";
import BoarCard from "./cards/BoarCard";
import BasicInfoGroupBox from "./BasicInfoGroupBox";
import GroupCard from "./cards/GroupCard";
import {connect} from "react-redux";
import RenovationSowCard from "./cards/RenovationSowCard";
import InfoBox from "../basics/info-box/InfoBox";
import {EventTypes} from "../../constans/eventTypes";
import {get} from "lodash";
import {bindActionCreators, compose} from "redux";
import {withTranslation} from "react-i18next";
import withRoles from "../withRoles";
import * as RoleTypes from "@wesstron/utils/Api/constants/roleTypes";
import PorkerPigletCard from "./cards/PorkerPigletCard";
import Button from "../basics/button/Button";
import AnimalRemoveEventModal, {
    ModalName as AnimalRemoveEventModalName,
} from "../modals-new/animal-remove-event-modal/AnimalRemoveEventModal";
import {show} from "redux-modal";
import {getSelectedAnimalForDocuments} from "../../selectors/animalDocumentsSelectors";
import LicensePaths from "../../constans/LicensePaths";

function mapStateToProps(state) {
    return {
        selectedItem: state.animalDocuments.selectedItem,
        selectionReasons: state.dictionary.selectionReason,
        lang: state.language.lang.lang,
        animal: getSelectedAnimalForDocuments(state),
    };
}

function mapDispatchToProps(dispatch) {
    return {
        dispatch,
        ...bindActionCreators({show}, dispatch),
    };
}
class DocumentBody extends Component {
    deleteEventClick = (events) => {
        const {show} = this.props;
        show(AnimalRemoveEventModalName, {
            selectedEvent: events,
        });
    };

    getSelectionInfoBox = () => {
        const {
            events,
            selectionReasons: {WData},
            t,
        } = this.props;
        const sensitiveEvents = events.filter((e) =>
            [EventTypes.SELL, EventTypes.FALL].includes(e.EvCode)
        );
        const selections = events.filter(
            (e) => e.EvCode === EventTypes.SELECTION
        );
        if (selections.length && sensitiveEvents.length === 0) {
            let reason = WData.find(
                (item) => item.ID === selections[0].EvData.Reasn
            );
            return (
                <InfoBox
                    className="d-flex align-items-center"
                    boxColor="warning">
                    <i className="fas fa-clipboard-check ms-2 me-2" />
                    {t("animalDocuments.hasBeenSelected", {
                        reason: get(reason, "Value", ""),
                    })}
                    <Button
                        onClick={() => this.deleteEventClick(selections)}
                        className="mb-0 ms-auto"
                        buttonStyle="text"
                        buttonColor="warning"
                        text={t("back")}
                    />
                </InfoBox>
            );
        }
        return null;
    };

    render() {
        const {selectedItem, events, mobile, loading, animal} = this.props;
        if (!selectedItem) return null;
        return (
            <>
                {!loading && selectedItem?.AnmID && (
                    <>
                        {this.getSelectionInfoBox()}
                        <BasicInfoBox
                            showEdit={true}
                            events={events}
                            animal={selectedItem}
                        />
                        {selectedItem.AnimalKind !== undefined && (
                            <>
                                {selectedItem.AnimalKind ===
                                    AnimalTypes.RENOVATION_SOW && (
                                    <RenovationSowCard animal={animal} />
                                )}
                                {selectedItem.AnimalKind ===
                                    AnimalTypes.SOW && (
                                    <SowCard mobile={mobile} animal={animal} />
                                )}
                                {selectedItem.AnimalKind ===
                                    AnimalTypes.BOAR && (
                                    <BoarCard animal={animal} />
                                )}
                                {[
                                    AnimalTypes.PIGLET,
                                    AnimalTypes.PORKER,
                                ].includes(selectedItem.AnimalKind) && (
                                    <PorkerPigletCard />
                                )}
                                <AnimalRemoveEventModal animal={selectedItem} />
                            </>
                        )}
                    </>
                )}
                {!loading && selectedItem?.AnmGrp && (
                    <>
                        <BasicInfoGroupBox />
                        <GroupCard />
                    </>
                )}
            </>
        );
    }
}

export default compose(
    withTranslation(),
    connect(mapStateToProps, mapDispatchToProps),
    withRoles({
        roles: [RoleTypes.BREEDING],
        showComponent: true,
        requiredLicenses: {
            or: [LicensePaths.BREEDING_SOW, LicensePaths.BREEDING_PORKER],
        },
    })
)(DocumentBody);
